import React from 'react';
import { Phone } from 'lucide-react';
export function CtaBanner({
  heading
}: {
  heading: string;
}) {
  const scrollToForm = () => {
    document.getElementById('quote-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-red py-10" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-21">
          <h2 className="text-2xl md:text-3xl font-black text-white text-center md:text-left max-w-2xl" data-id="element-22">
            {heading}
          </h2>
          <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto shrink-0" data-id="element-23">
            <a href="tel:+17543251100" className="flex items-center justify-center gap-2 text-white hover:text-slate-200 font-bold text-lg transition-colors" data-id="element-24">
              <Phone className="w-5 h-5" data-id="element-25" />
              (754) 325-1100
            </a>
            <button onClick={scrollToForm} className="bg-white text-brand-red hover:bg-slate-100 font-bold py-3 px-8 rounded-lg shadow-md transition-all w-full sm:w-auto text-lg" data-id="element-26">
              Get My Free Quote
            </button>
          </div>
        </div>
      </div>
    </section>;
}